export default "61078d1e74312541.svg"